import LocalDataService from "@/service/LocalDataService";
import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "@/store/index";
import ApiMe from "@/api/ApiMe";

import { OperationCompanyResponse, OperationMeResponse } from "chaild-api/lib/index";
import { PostMeRequest } from "@/model/Request";

export interface MeState {
  me: OperationMeResponse | null;
  nurseryId: number | null; // Navigation Drawerでの出し分け用
  company: OperationCompanyResponse | null;
}

@Module({ dynamic: true, store, name: "me", namespaced: true })
class MeModule extends VuexModule implements MeState {
  public me: OperationMeResponse | null = null;
  public nurseryId: number | null = null;
  public company: OperationCompanyResponse | null = null;

  @Action({ rawError: true })
  public async fetchMe() {
    const response = await ApiMe.fetchMe().catch((e) => {
      if (e.error) {
        return e;
      }
    });
    if (response) {
      LocalDataService.setUser(response);
      this.setMe(response);
    }
    return response;
  }

  @Action({ rawError: true })
  public async postMe(request: PostMeRequest) {
    const response: OperationMeResponse = await ApiMe.postMe(request);
    LocalDataService.setUser(response);
    return true;
  }

  @Action({ rawError: true })
  public async postWithNoBody() {
    const response = await ApiMe.postWithNoBody();
    if (response) {
      return response;
    }
  }

  @Action({ rawError: true })
  public async putMe(input: { defaultNurseryId: number }) {
    const response = await ApiMe.putMe(input);
    if (response) {
      this.setMe(response);
      return response;
    }
  }

  @Mutation
  public setMe(value: OperationMeResponse) {
    this.me = value;
  }

  @Mutation
  public setNurseryId(value: number) {
    this.nurseryId = value;
  }

  @Mutation
  public setCompany(value: OperationCompanyResponse) {
    this.company = value;
  }
}

export const meModule = getModule(MeModule);
